import React from 'react'
import { ReactComponent as Finger } from '../../assets/icons/finger.svg'
import { ReactComponent as PaintFill } from '../../assets/icons/paint-fill.svg'

export default function TopPanel({ isDev, isPenMode, setIsPenMode, isLeader, setIsLeader }) {
  const onClickPenMode = () => {
    setIsPenMode(!isPenMode)
  }

  const onClickLeader = () => {
    setIsLeader(!isLeader)
  }

  return (
    <div
      className={`${isDev ? 'sg-block' : 'sg-hidden'} sg-absolute sg-top-0 sg-left-0 sg-z-[99999]`}
    >
      <div className='sg-flex sg-items-center sg-justify-center sg-gap-8 sg-px-10 sg-py-6 sg-rounded-br-[10px] sg-bg-sk-white sg-shadow-default2'>
        <div
          onClick={onClickPenMode}
          className={`sg-p-6 ${
            isPenMode
              ? 'sg-bg-sk-primary sg-text-sk-white'
              : 'sg-bg-sk-background-alternative sg-text-sk-sub'
          } sg-rounded-[4px] sg-cursor-pointer`}
        >
          <Finger />
        </div>
        <div
          onClick={onClickLeader}
          className={`sg-p-6 ${
            isLeader
              ? 'sg-bg-sk-primary sg-text-sk-white'
              : 'sg-bg-sk-background-alternative sg-text-sk-sub'
          } sg-rounded-[4px] sg-cursor-pointer`}
        >
          <PaintFill />
        </div>
        <p className='sg-z-[99999]'>{isLeader ? 'true' : 'false'}</p>
        {document.getElementById('sg-canvas') && (
          <p>{document.getElementById('sg-canvas').getBoundingClientRect().width}</p>
        )}
        {document.getElementById('sg-canvas') && (
          <p>{document.getElementById('sg-canvas').getBoundingClientRect().height}</p>
        )}
      </div>
    </div>
  )
}
